/**
 *
 * @desc Class of url constant manager
 */
import { REACT_APP_GOOGLE_MAP_KEY } from "../config/Constants";
class UrlConstants {
  constructor() {
    const YOUR_API_KEY = REACT_APP_GOOGLE_MAP_KEY;
    this.SiteUrl = process.env.REACT_APP_SITE_URL;
    this.BaseUrl = process.env.REACT_APP_API_URL + "api/";
    this.resetBaseUrl = process.env.REACT_APP_SITE_URL;

    this.LoginUrl = this.BaseUrl + "auth";
    this.RegisterUrl = this.BaseUrl + "users";
    this.RegisterWithoutPlanUrl = this.BaseUrl + "users/userWithoutPlan";
    this.InviteAgentUrl = this.BaseUrl + "users/inviteBuyerAgent";
    this.RegistrationRequestsUrl =
      this.BaseUrl +
      "users/notactive?limit={recordPerPage}&lastsync={modifieddate}&offset={pageIndex}";
    this.ApproveUserAccountUrl =
      this.BaseUrl + "users/" + "{userID}" + "/admin";
    this.BuyerAgentListUrl =
      this.BaseUrl +
      "users/type/Acctowner?limit={recordPerPage}&offset={pageIndex}";
    this.getAllOwnersData =
      this.BaseUrl +
      "users/getAllOwnersData/Acctowner?limit={recordPerPage}&offset={pageIndex}";
    this.VendorsListUrl =
      this.BaseUrl +
      "users/type/Vendor?limit={recordPerPage}&offset={pageIndex}";
    this.BuyerListUrl =
      this.BaseUrl +
      "users/type/Buyer?limit={recordPerPage}&offset={pageIndex}";
    this.MyProfileUrl = this.BaseUrl + "users/me";
    this.getProfileUrl = this.BaseUrl + "users/";
    this.uploadAvatarUrl = this.BaseUrl + "users/uploadAvatar";

    this.AdminGetMaterTemplateUrl = this.BaseUrl + "template";
    this.setVendorPassword = this.BaseUrl + "users/changePassword";
    this.AdminUpdateCampMaterTemplateUrl =
      this.BaseUrl + "template?model={model}&campaignId={campaignId}";
    this.AdminUpdateBothMaterTemplateUrl =
      this.BaseUrl +
      "template?eventtemplateId={eventTempId}&communicationtemplateId={commuId}";

    this.AdminCreatEventCommMaterTemplateUrl = this.BaseUrl + "template";
    this.AdminDeleteEventCommMaterTemplateUrl =
      this.BaseUrl + "template?eventtemplateId={eventtemplateId}";

    this.AdminGetCampDataByIdMaterTemplateUrl =
      this.BaseUrl + "template?campaign={campId}";
    this.AdminCreatCampaignMaterTemplateUrl =
      this.BaseUrl + "template?model=campaign";
    this.AdminCopyCampaignMaterTemplateUrl = this.BaseUrl + "copytemplates";

    this.AdminGetVarriableRefMaterTemplateUrl = this.BaseUrl + "variable";
    this.AdminGetVariableRefMaterTemplateUrl =
      this.BaseUrl +
      "template/variable?systemCampaignStyleId={systemCampaignStyleId}";

    this.AdminGetContingencyUrl = this.BaseUrl + "contingencies";

    this.getVarriableRefTransactionUrl =
      this.BaseUrl + "transactions/variable?transactionId=";

    this.AdminCreateTransactionUrl = this.BaseUrl + "transactions";
    this.inprogressTransactionUrl =
      this.BaseUrl + "transactions/inProgressListing";
    this.AdminCreateNewTransactionUrl = this.BaseUrl + "transactions/new";
    this.GetTransactionUrl = this.BaseUrl + "transactions?id={transactionsId}";
    this.UpdateTransactionUrl =
      this.BaseUrl + "transactions?id={transactionsId}";
    this.DeleteTransactionUrl =
      this.BaseUrl + "transactions?id={transactionsId}";

    this.timezoneUrl = this.BaseUrl + "timezone";

    this.leadSourceUrl = this.BaseUrl + "leadsource";

    this.uploadPropertyImage = this.BaseUrl + "transactions/uploadImage";

    this.addContact = this.BaseUrl + "contact";

    this.buyerAgentMasterTemplate = this.BaseUrl + "usertemplate";

    this.roles = this.BaseUrl + "roles";

    this.userRole = this.BaseUrl + "userrole";

    this.allContingencies = this.BaseUrl + "contigencymap";

    this.contingencies = this.BaseUrl + "contingencies";

    this.transactionEvent = this.BaseUrl + "transactionevent";
    this.aftercareFormSubmit =
      this.BaseUrl + "publicforms/createAfterCareForm";

    this.specialTask = this.BaseUrl + "specialtasktype";

    this.comments = this.BaseUrl + "comments?id=";

    this.forgotpassword = this.BaseUrl + "users/forgot";
    this.forgotpasswordNew = this.BaseUrl + "users/forgotNew";
    this.forgotUserNameNew = this.BaseUrl + "users/forgotUserName";
    this.validateResetPasswordToken = this.BaseUrl + "users/reset/";
    this.validateResetPasswordTokenNew = this.BaseUrl + "users/resetNew/";
    this.getInvitedUserDetail = this.BaseUrl + "users/registration/";
    this.getPendingProfileListUrl =
      this.BaseUrl +
      "users/incompleteprofile?limit={recordPerPage}&offset={pageIndex}";

    this.removeRegistrationRequest = this.BaseUrl + "users?id=";
    this.rejectRegistrationRequest = this.BaseUrl + "users/rejectData?id=";
    this.rejectedRegistrationList =
      this.BaseUrl +
      "users/rejectedUser/true?limit={recordPerPage}&offset={pageIndex}";
    this.setDependency = this.BaseUrl + "dependency?";

    this.docsPaginateUrl = this.BaseUrl + "comments/getDocumentListing";
    this.userDocsPaginateUrl = this.BaseUrl + "comments/getUserDocumentListing";

    this.docsUrl =
      this.BaseUrl + "comments/getAttachment?transactionId={transactionId}";
    this.addDocUrl = this.BaseUrl + "comments/attachment";
    this.publicAddDocUrl = this.BaseUrl + "public/form/attachment";
    this.uploadDocUrl =
      this.BaseUrl + "comments/uploadDocument?id={transactionId}";
    this.publicUploadDocUrl =
      this.BaseUrl + "public/form/uploadDocument?id={transactionId}";
    this.archiveDocumentUrl = this.BaseUrl + "comments/archeiveDocument?id=";
    this.viewDocUrl =
      this.BaseUrl + "transactions/upload?id={transactionId}&img=";
    this.downloadDocUrl =
      this.BaseUrl +
      "comments/downloadDocument?id={transactionId}&documentId={documentId}&img=";
    this.deleteDocumentFromTask =
      this.BaseUrl + "comments/deleteAttachment?id=";
    this.removeFolderUrl = this.BaseUrl + "comments/removeFolder";
    this.folderList =
      this.BaseUrl +
      "comments/getListOfFolder?transactionId={transactionId}&folderName={folderName}";
    this.moveDocumentUrl =
      this.BaseUrl + "comments/moveDocument?id={documentId}";
    this.folderPermission =
      this.BaseUrl +
      "comments/getFolderPermission?transactionId={transactionId}&folderName={folderName}";
    this.setFolderPermissionUrl = this.BaseUrl + "comments/setFolderPermission";
    this.removeDocumentUrl = this.BaseUrl + "comments/removeAttachment?id=";

    this.sendDocumentNotification =
      this.BaseUrl + "comments/sendDocumentNotification?id={transactionId}";

    this.vendorTransactionsUrl =
      this.BaseUrl + "transactions/vendorTransactionList?id={id}";
    this.vendorTasksUrl =
      this.BaseUrl +
      "transactionevent/vendorTransactionEvents?vendorId={vendorId}&transactionId={transactionId}";
    this.buyerTasksUrl =
      this.BaseUrl + "transactionevent/buyerTransactionEvents?transactionId=";
    this.transactionStatusUrl =
      this.BaseUrl + "transactions/status?id={transactionId}";

    this.emailCheckUrl = this.BaseUrl + "users/email";
    this.usernameCheckUrl = this.BaseUrl + "users/duplicatecheckusername";

    this.uploadDependentTaskURL =
      this.BaseUrl + "template/dependency?eventtemplateId=";
    this.updateBuyerDependentTaskURL =
      this.BaseUrl + "usertemplate/dependency?usereventtemplateId=";

    this.removeDependencyBuyer =
      this.BaseUrl + "dependency?id={id}&removeId={removeId}";

    this.activitiesOfBuyerAgent = this.BaseUrl + "activitylogs?referenceId=";
    this.activityUser = this.BaseUrl + "transactionevent/filter?transactionId=";

    this.buyerTransactionsList =
      this.BaseUrl + "transactions/buyerTransactionList";

    this.listAllCalendarEvents = this.BaseUrl + "transactions/calenderEvents";

    this.DashboardTransactionsUrl = this.BaseUrl + "dashboard/table1";
    this.DashboardwidgetFourUrl = this.BaseUrl + "dashboard/table2";
    this.TransactionValuesWidgetDataUrl = this.BaseUrl + "dashboard/table3";
    this.CommissionWidgetDataUrl = this.BaseUrl + "dashboard/table4";
    this.homeBuyerContacts =
      this.BaseUrl + "transactionevent/homebuyerVendor?transactionId=";
    this.homeVendorContacts =
      this.BaseUrl + "transactionevent/homevendorVendor?transactionId=";
    this.DashboardTaskListingUrl = this.BaseUrl + "dashboard/listing";

    this.AdminUsersListUrl = this.BaseUrl + "users/type/admin";
    this.AdminAddUserUrl = this.BaseUrl + "users/admin";

    this.ChangePasswordUrl = this.BaseUrl + "users/changePassword?profile=true";

    this.ChangePasswordUrlNew =
      this.BaseUrl + "users/changePasswordNew?profile=true";

    this.checkTransShortNameUrl =
      this.BaseUrl + "transactions/checkshortname?shortName=";

    this.threadsUrl = this.BaseUrl + "discussion/contact?transactionId=";
    this.messagesUrl = this.BaseUrl + "discussion/contactId?transactionId=";
    this.replyUrl = this.BaseUrl + "discussion/reply";
    this.resendUrl = this.BaseUrl + "discussion/resend";

    this.emailTemplatesUrl = this.BaseUrl + "mail";

    this.adminSysNotification = this.BaseUrl + "systemNotifications";
    this.userNotification = this.BaseUrl + "notifications";
    this.userNotificationListing = this.BaseUrl + "userNotifications";
    this.notificationUnreadCnt = this.BaseUrl + "notifications/count";

    this.subscriptionCounterUrl =
      this.BaseUrl + "subscription?limit={recordPerPage}&offset={pageIndex}";
    this.newSubscriptionUrl =
      this.BaseUrl + "subscription/setUpNewSubscription";
    this.uploadSubscriptionDocUrl =
      this.BaseUrl + "subscription/uploadDocument";
    this.getSubscriptionUrl =
      this.BaseUrl + "subscription/getSubcriptionSetUp?subscriptionType=";
    this.subscriptionImgUrl =
      this.BaseUrl + "subscription/downloadDocument?img=";
    this.deleteImgUrl = this.BaseUrl + "subscription/deleteImage";
    this.updateSubscriptionUrl =
      this.BaseUrl + "subscription/updateSubscriptionSetUp?id=";
    this.removeProductUrl = this.BaseUrl + "subscription/removeProduct?id=";
    this.archiveSubscriptionUrl =
      this.BaseUrl + "subscription/updateArchiveStatus?id=";
    this.getAccountInfoUrl = this.BaseUrl + "subscription/accountInformation";
    this.cancelSubscriptionUrl =
      this.BaseUrl + "subscription/cancelSubscriptionAtPeriodEnd";
    this.getProrationUrl =
      this.BaseUrl + "subscription/previewProration?newPriceId={newPriceId}";
    this.reActivateSubscriptionUrl =
      this.BaseUrl + "subscription/reactivateSubscription";
    this.changeSubscriptionurl =
      this.BaseUrl + "subscription/changeSubscription";
    this.activateSubscriptionurl = this.BaseUrl + "subscription/activatePlan";
    this.addPaymentUrl = this.BaseUrl + "users/addPaymentMethod";
    this.updatePaymentUrl = this.BaseUrl + "users/updateCustomerPaymentMethod";
    this.removePaymentUrl = this.BaseUrl + "users/removePaymentMethod";
    this.invoiceListUrl = this.BaseUrl + "subscription/getInvoiceList";
    this.stripeSetting = this.BaseUrl + "subscriptionsetting";
    this.planSettingUrl = this.BaseUrl + "subscriptionsetting/update";
    this.subscriptionProvider = this.BaseUrl + "subscriptionprovider";
    this.updateProvider = this.BaseUrl + "subscriptionprovider/update";
    this.googleMapAPIUrl =
      "https://maps.googleapis.com/maps/api/geocode/json?key=" +
      YOUR_API_KEY +
      "&address=";
    this.tellagentSupportBaseUrl = "https://support.tellagent.com";
    this.hearAboutUsUrl = this.BaseUrl + "hearaboutus";
    this.deleteHearAboutUsUrl = this.BaseUrl + "hearaboutus/deletehearaboutus";
    this.updateHearAboutUsUrl = this.BaseUrl + "hearaboutus/updatehearaboutus";
    this.transactionTypeUrl = this.BaseUrl + "transactionType";
    this.updateTransactionTypeUrl =
      this.BaseUrl + "transactionType/updatetransactiontype";
    this.deleteTransactionTypeUrl =
      this.BaseUrl + "transactionType/deletetransactiontype";
    this.deleteSystemCampaignUrl =
      this.BaseUrl + "template/deletesystemcampaign";
    this.deleteUserCampaignUrl =
      this.BaseUrl + "usertemplate/deleteusercampaign";
    this.editBuyerUserEmailUrl = this.BaseUrl + "users/updateuseremail";
    this.reActivateDeletedUserUrl = this.BaseUrl + "users/activateuseraccount";
    this.searchUserUrl = this.BaseUrl + "users/searchusertype";
    this.reActivateDeletedContactUrl =
      this.BaseUrl + "contact/reactivate_contact";
    this.addPublicFormUrl = this.BaseUrl + "publicforms/createForm";
    this.updatePublicFormUrl = this.BaseUrl + "publicforms/updateForm";
    this.deletePublicFormUrl = this.BaseUrl + "publicforms/deleteForm";
    this.getPublicFormByIdUrl = this.BaseUrl + "publicforms/getFormById";
    this.isPublicFormValidUrl = this.BaseUrl + "publicforms/isValid";
    this.generateQRcodeUrl = this.BaseUrl + "publicforms/generateQRcode";
    this.createQRcodeUrl = this.SiteUrl + "publicforms/{publicFormId}/{token}";

    this.addBilingitems = this.BaseUrl + "billingConfig/addbillingitem";
    this.editBilingitems = this.BaseUrl + "billingConfig/editBilingitems";
    this.getallBilingitems = this.BaseUrl + "billingConfig/getallbillingitem";

    this.billingSetting = this.BaseUrl + "billingConfig/getApplication/";
    this.updatebillingSetting = this.BaseUrl + "users/updateStripeStatus";
    this.billingPlan = this.BaseUrl + "billingConfig/addbillingplan/";
    this.getapplication = this.BaseUrl + "billingConfig/application";

    this.getBillingPaymentDetails = this.BaseUrl + "invoice/getInvoiceDetails";
    this.getAllbillingPlans = this.BaseUrl + "billingConfig/getAllbillingPlans";
    this.updateIsactiveIsdefault =
      this.BaseUrl + "billingConfig/updateIsactiveIsdefault";
    this.getbillingPlanByid = this.BaseUrl + "billingConfig/getbillingPlanByid";
    this.updateHoleBillinplan =
      this.BaseUrl + "billingConfig/updateHoleBillinplan";
    this.createOrUpdateInvoice = this.BaseUrl + "invoice";
    this.getCurrentCredit = this.BaseUrl + "billingConfig/getCredit/";
    this.updateCurrentCredit = this.BaseUrl + "billingConfig/updateCredit";
    this.changeBillingPlan = this.BaseUrl + "billingConfig/changeBillingplan";
    this.getBillingHistory = this.BaseUrl + "invoice/getAllInvoice";

    this.updateBillingPaymentMethodUrl =
      this.BaseUrl + "billingConfig/updateCustomerPaymentMethod";
    this.getUserBillingPaymentMethodUrl =
      this.BaseUrl + "billingConfig/getPaymentMethod";

    this.updateAuthDbUrl = this.BaseUrl + "contact/updateauthdb";
    this.getInvoiceByPeriodUrl =
      this.BaseUrl + "invoice/getInvoicebyinvoiceperiod";
    this.getAllOwnersBillingHistoryUrl =
      this.BaseUrl + "invoice/getAllownersInvoices";
    this.getAllAccOwnersUrl = this.BaseUrl + "users/getallowneslisting";
    this.billingPaymentCaptureUrl =
      this.BaseUrl + "invoice/payFailspaymentByadmin";
    this.checkplanisUsedorNot =
      this.BaseUrl + "billingConfig/checkplanisUsedorNot";

    this.getAllAccOwnersUrl = this.BaseUrl + "users/getallowneslisting";
    this.getPermissionUrl = this.BaseUrl + "users/getpermissions";
    this.Getcompanylist = this.BaseUrl + "users/getcompanylist";
    this.userRoleNew = this.BaseUrl + "userrole" + "/newusserroles";
    this.updatetoken = this.BaseUrl + "users/updatetoken";
    this.RegisterWithBillingUrl = this.BaseUrl + "users/registerWithBilling";
    this.Testtimezones = this.LoginUrl + "/timezonestest";

    this.AdminCreateTransactionUrlNew =
      this.BaseUrl + "transactions/accountOwnerTransactions";
    this.vendorTransactionsUrlNew =
      this.BaseUrl + "transactions/venderOwnerTransaction?id={id}";

    this.getQuickAppointmentUrl =
      this.BaseUrl + "usertemplate/quick-appointment";

    this.pathwaybuyerAgentMasterTemplate = this.BaseUrl + "userpathwaytemplate";
    this.pathwayupdateBuyerDependentTaskURL =
      this.BaseUrl + "userpathwaytemplate/dependency?usereventtemplateId=";
    this.pathwaydeleteUserCampaignUrl =
      this.BaseUrl + "userpathwaytemplate/deleteusercampaign";
    this.addPathwayToTransactionUrl = this.BaseUrl + "transactions/addpathway";
    this.getTransactionPathwaysListUrl =
      this.BaseUrl + "transactions/getpathway";
    this.deleteTransactionPathway = this.BaseUrl + "transactions/deletepathway";

    //admin pathways master template urls
    this.pathwayAdminCopyCampaignMaterTemplateUrl =
      this.BaseUrl + "copypathwaytemplates";

    this.pathwayAdminGetMaterTemplateUrl = this.BaseUrl + "templatepathway";
    this.pathwayAdminGetCampDataByIdMaterTemplateUrl =
      this.BaseUrl + "templatepathway?campaign={campId}";
    this.pathwayAdminCreatCampaignMaterTemplateUrl =
      this.BaseUrl + "templatepathway?model=campaign";
    this.pathwayAdminCreatEventCommMaterTemplateUrl =
      this.BaseUrl + "templatepathway";
    this.pathwayAdminDeleteEventCommMaterTemplateUrl =
      this.BaseUrl + "templatepathway?eventtemplateId={eventtemplateId}";
    this.pathwayUploadDependentTaskURL =
      this.BaseUrl + "templatepathway/dependency?eventtemplateId=";
    this.pathwayAdminUpdateCampMaterTemplateUrl =
      this.BaseUrl + "templatepathway?model={model}&campaignId={campaignId}";
    this.pathwayAdminUpdateBothMaterTemplateUrl =
      this.BaseUrl +
      "templatepathway?eventtemplateId={eventTempId}&communicationtemplateId={commuId}";
    this.pathwayAdminDeleteSystemCampaignUrl =
      this.BaseUrl + "templatepathway/deletesystempathwaycampaign";

    this.pathwaySetDependency = this.BaseUrl + "pathwaydependency?";

    this.appoVendorContingenciesUrl =
      this.BaseUrl +
      "transactions/appoVendorContingenciesList?id={id}&transactionId={transactionId}";
    this.appoVendorTransactionsUrl =
      this.BaseUrl +
      "transactions/appoVendorTransactionList?id={id}&ownerId={ownerId}";
    this.RegisterinvitedAccounowner =
      this.BaseUrl + "users/registerInvitebyadmin";

    this.Role = this.BaseUrl + "role";
    this.getPaymentReceipt = this.BaseUrl + "invoice/findreceipt";
    this.activateAdminUser = this.BaseUrl + "users/activateAdminUser";
    this.generateimage = this.BaseUrl + "tellagentAi/generateImage";
    this.getaimodel = this.BaseUrl + "users/getaimodel";
    this.updategptmodel = this.BaseUrl + "users/updategptModel";
    this.generateimagevariations = this.BaseUrl + "tellagentAi/imagevariations";
    this.editImage = this.BaseUrl + "tellagentAi/editImage";
    this.getBillingItemForpermissions =
      this.BaseUrl + "invoice/getbillingitems";
    this.getInvoicebyinvoiceid = this.BaseUrl + "invoice/getInvoicebyinvoiceid";
    this.deleteNewPlan = this.BaseUrl + "billingConfig/deleteNewPlan";
    this.updateCurrentplanEnddate =
      this.BaseUrl + "billingConfig/updateCurrentplanEnddate";

    this.getAllAppointmentsUrl =
      this.BaseUrl + "transactions/calanderAppointmentEvents";

    this.getStripeKeyUrl = this.BaseUrl + "billingConfig/WEbEOpurMgk";

    this.allArtistsVendorsListUrl =
      this.BaseUrl +
      "users/byrole/Artist?limit={recordPerPage}&offset={pageIndex}";

    this.systemBannersUrl = this.BaseUrl + "systembanner";
    this.systemversionUrl = this.BaseUrl + "systemversion";

    this.getSystemBannersUrl =
      this.BaseUrl +
      "systembanner/getAllBanner?limit={recordPerPage}&offset={pageIndex}";

    this.getSystemVersionsUrl =
      this.BaseUrl +
      "systemversion/all?limit={recordPerPage}&offset={pageIndex}";

    this.AddaiVersion = this.BaseUrl + "tellagentAi/AddAiversion";
    this.GetaiVersion = this.BaseUrl + "tellagentAi/getAiVersions";
    this.UpdateAiVersion = this.BaseUrl + "tellagentAi/UpdateAiVersion";
    this.AssignVersion = this.BaseUrl + "tellagentAi/AssignVersion";
    this.GetAllassignedVersion =
      this.BaseUrl + "tellagentAi/getAllassignedVersion";
    this.updateAiVersionToparticularService =
      this.BaseUrl + "tellagentAi/updateAiVersionToparticularService";
    this.GetparticularVersion =
      this.BaseUrl + "tellagentAi/getparticularVersion";

    this.getContactsbytransactionid =
      this.BaseUrl + "contact/getcontactbytransactionid";

    this.getcontactbycontactid = this.BaseUrl + "contact/getcontactbycontactid";

    this.userDocsUrl = this.BaseUrl + "comments/getUserAttachment";
    this.addUserDocUrl = this.BaseUrl + "comments/user/attachment";
    this.uploadUserDocUrl = this.BaseUrl + "comments/user/uploadDocument";
    this.removeUserDocumentUrl =
      this.BaseUrl + "comments/removeUserAttachment?id=";
    this.userFolderList =
      this.BaseUrl + "comments/getUserListOfFolder?folderName={folderName}";
    this.downloadUserDocUrl =
      this.BaseUrl +
      "comments/downloadUserDocument?contactId={contactId}&ownerId={ownerId}&documentId={documentId}&img=";
    this.setUserFolderPermissionUrl =
      this.BaseUrl + "comments/setUserFolderPermission";

    this.cardProcessUrl = this.BaseUrl + "cardprocess";
    this.cardInvoicesUrl = this.BaseUrl + "appcardInvoices";

    this.shopsUrl = this.BaseUrl + "public/shops";
    this.shopDetailsUrl = this.BaseUrl + "public/shops/details?id={ownerId}";
    this.artistDetailsUrl =
      this.BaseUrl +
      "public/shops/artistsDetailsById?artistId={artistId}&ownerId={ownerId}";
    this.getRolesPublicUrl =
      this.BaseUrl + "public/shops/newusserroles?ownerId={ownerId}";
    this.publicProfileUrl = this.SiteUrl + "studios/";
    this.artistPublicProfileUrl = this.SiteUrl + "artists/";

    this.bookTransactionStatusUrl =
      this.BaseUrl + "public/shops/status?id={transactionId}";

    this.getAiPromptListUrl = this.BaseUrl + "aiPrompt/getAiPrompts";
    this.addAiPromptUrl = this.BaseUrl + "aiPrompt/addAiPrompt";
    this.updateAiPromptUrl = this.BaseUrl + "aiPrompt/updateAiPrompt?id={id}";
    this.getAiPromptDetailsUrl =
      this.BaseUrl + "aiPrompt/promptDetails?id={id}";
    this.updateAiPromptStatusUrl =
      this.BaseUrl + "aiPrompt/updateDefaultAiPrompt";

    this.categoryUrl = this.BaseUrl + "category";
    this.getOneAiCatUrl = this.BaseUrl + "category/getCategoryDetails?id={id}";
    this.updateCategoryStatusUrl = this.BaseUrl + "category/activeInactive";

    this.subCategoryUrl = this.BaseUrl + "subCategory";
    this.updateSubCategoryUrl = this.BaseUrl + "subCategory?id={id}";
    this.getAiOneSubCategoryUrl = this.BaseUrl + "subCategory/edit?id={id}";
    this.updateSubCategoryStatusUrl =
      this.BaseUrl + "subCategory/activeInactive";
    this.getAiCatSubUrl =
      this.BaseUrl + "subCategory/activeSubcategory?categoryId={categoryId}";
    this.updateAiModelSetting = this.BaseUrl + "users/updateApplicationAiModel";

    this.getAllAiAssignedVersions=this.BaseUrl + "assignedVersion/getAllAssignedVersion"
    this.assignVersionToService=this.BaseUrl + "assignedVersion/addAssignedVersion"
    this.getAiserviceUrl = this.BaseUrl + "assignedVersion/getAiServices";
    this.getAllAiVersions = this.BaseUrl + "tellagentAi/getAiVersions";
    this.updateAiAssignedVersionUrl =
    this.BaseUrl + "assignedVersion/updateAssignedVersion";
    this.addAiAssignedVersionUrl =
    this.BaseUrl + "assignedVersion/addAssignedVersion";
//masterlokup urls

this.getAllMasterListing = this.BaseUrl + "lookUpCategories";
this.addToMasterListing = this.BaseUrl + "lookUpCategories/add";
this.updateLookUpCategories =
  this.BaseUrl + "lookUpCategories/update?id={id}";
this.updatActiveInActiveStatus =
  this.BaseUrl + "lookUpCategories/activeInactive?id={id}";

this.getAllMasterListingSubCat = this.BaseUrl + "lookUpMasterData";
this.addToMasterLookSubCat = this.BaseUrl + "lookUpMasterData/add";
this.updateMasterData = this.BaseUrl + "lookUpMasterData/update?id={id}";
this.updateMasterDataStatus =
  this.BaseUrl + "lookUpMasterData/activeInactive?id={id}";
this.getMasterdatabyStatuscode =
  this.BaseUrl + "lookUpMasterData/getMasterDataByShortcode?shortcode={id}";
this.getPublicformDetailsUrl = this.BaseUrl + "public/publicFormDetails";
  }
}

export default new UrlConstants();
